<template>
  <div id="adMapBox" :class="{'region_map_box': true, 'adjust': !init}">
    <div id="mapContainer" class="map_container"></div>
    <RegionInfoPop :top-left="poperStyle" :info="hoverProvince" />
    <SearchFeatures v-if="!init" v-model="putRange" @zoomChange="onZoomChange" @reDraw="onReDraw" @search="onSearch" />
    <div v-if="searchNone" class="search_none">暂无数据</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Loading } from 'element-ui'
import { loadAmap, geoLocation, GeoUtil } from '@/utils/AMapUtil'
import { deepClone } from '@/utils/functions'
import RegionInfoPop from './RegionInfoPop'
import SearchFeatures from './MapSearchFeatures'
import drawCircle from './drawCircleMixin.js'

const PathPre = '/map/'
const pointIcon = require('@/assets/map_location.png')

let mapIcon = null
let focusLayer = null

export default {
  name: 'RegionMap',
  components: { RegionInfoPop, SearchFeatures },
  props: {
    init: {
      type: Boolean,
      default: true
    },
    nbhdSearchFn: {
      type: Function,
      required: true
    }
  },
  mixins: [drawCircle],
  data() {
    return {
      poperStyle: { left: 0, top: 0 },
      hoverProvince: {},
      // 投放范围半径
      putRange: 9,
      searchNone: false
    }
  },
  computed: {
    ...mapState({
      curZoom: state => state.bmap.mapZoom,
      curDist: state => state.bmap.mapZoomData,
      curFocus: state => state.bmap.focusPoint, // 搜索到的目标点
      searchedIds: state => state.bmap.nbhdBasic, // 搜索结果小区ID集合
      manualDraw: state => state.bmap.manualDraw, // 画圈选屏
      importData: state => state.bmap.exportPointData,
      resetOperate: state => state.bmap.isOperateReset
    })
  },
  watch: {
    init(v) {
      if (v) {
        this.putRange = 9 // 点击返回将投放范围重置
      }
    },
    resetOperate(v) {
      if (v) {
        this.putRange = 9 // 点击重置将投放范围置为9公里
      }
    },
    putRange(v) {
      if (!this.isInitRequest && !this.resetOperate) {
        this.$emit('search')
      }
    },
    curFocus: {
      deep: true,
      handler(v) {
        if (focusLayer) window.pMap?.remove(focusLayer)
        if (v && v.location) {
          this.createFocus(v.location) // 根据经纬度定位
        } else {
          focusLayer = null
        }
      }
    },
    searchedIds: {
      deep: true,
      handler(v, o) {
        if (JSON.stringify(v) !== JSON.stringify(o)) {
          if (window._labelLayer) {
            window.pMap.remove(window._labelLayer)
            window._labelLayer = null
          }
          this.$nextTick(() => {
            this.createNbhdMarker()
          })
        }
      }
    }
  },
  beforeDestroy() {
    this.$root.$off('operateResetSetCity')
    window._hoverMarker?.remove()
    window._hoverMarker = null
    this.penDrawPolygon?.destroy()
    this.penDrawPolyline?.destroy()
    this.circleSearchOverlay?.destroy()
    window._labelLayer?.clearEvents()
    window._labelLayer?.clear()
    window.pMap?.clearMap()
    window.pMap?.clearEvents() // 清除地图实例绑定的所有事件
    window.pMap?.destroy()
    window.pMap = null
    window.removeEventListener('mapupdate', this.handleUpdate)
    document.body.removeEventListener('click', this.manuallyRemove)
  },
  mounted() {
    this.initMap()
    this.$root.$on('operateResetSetCity', () => {
      window._hoverMarker.remove()
    })
    window.addEventListener('mapupdate', this.handleUpdate)
    document.body.addEventListener('click', this.manuallyRemove)
  },
  methods: {
    manuallyRemove() {
      if (window.pMap && window._hoverMarker) {
        window.pMap.remove(window._hoverMarker)
      }
    },
    initMap() {
      loadAmap(() => {
        mapIcon = new AMap.Icon({
          size: [18, 25],
          image: pointIcon,
          imageSize: [18, 25]
        })
        const am = new AMap.Map('mapContainer', {
          center: [108.229644, 38.1087],
          zoom: 4.4,
          zooms: [4.2, 20],
          keyboardEnable: false,
          isHotspot: false,
          showBuildingBlock: false,
          // 5adce4c7d9f30e7bfcf8c5443c3078b0 969218fa7c5d16b8d599ed022651f6d2 8f58d40622b8f622dd75503988c07fa4
          mapStyle: 'amap://styles/dark'
        })
        am.addControl(new AMap.Scale({
          position: 'RB'
        }))
        am.on('zoomend', (e) => {
          this.$store.commit('setMapZoom', am.getZoom())
          // 未搜索小区时地图可以缩放返回
          if (this.init) {
            this.onZoomEnd()
          }
        })
        window.pMap = am

        const hoverM = new AMap.Marker({
          anchor: 'bottom-center',
          /**
           ** 向下偏移4,保证点标记能完全覆盖掉LabelMarker的鼠标响应区域,避免鼠标向下滑动触发
           ** 点标记的mouesout事件后又触发LabelMarker的mouseover事件导致点标记未从地图上移除
           */
          offset: [0, 4],
          topWhenClick: true,
          zIndex: 500
        })
        const vm = this
        hoverM.on('mouseout', function(e) {
          window.pMap.remove(window._hoverMarker)
        })
        hoverM.on('click', e => {
          const { nbhdId } = e.target.getExtData()
          // 文字点击展开列表对应的项
          vm.$root.$emit('mapListChooseItem', nbhdId)
        })
        window._hoverMarker = hoverM
        this.initData()
      })
    },
    onZoomEnd() {
      const zoom = window.pMap.getZoom()
      // 展示全国下的省份分布
      if (zoom <= 5.8 && this.curDist.province) {
        window.pMap.clearMap()
        this.initData()
        window.pMap.setZoomAndCenter(4.4, [108.229644, 38.1087])
        this.$store.commit('setZoomData', { ...deepClone(this.curDist), province: null })
      }
      // 重新请求某个省的城市列表并展示到地图上
      if (zoom <= 10 && this.curDist.city) {
        window.pMap.clearMap()
        this.$store.commit('setZoomData', { ...deepClone(this.curDist), city: null })
        this.renderOrSearch(this.curDist.province)
        this.$emit('backInit')
      }

      // // 重新请求某个城市的区/县列表并展示到地图上
      // if (zoom <= 12 && this.curDist.dist) {
      //   window.pMap.clearMap()
      //   this.$store.commit('setZoomData', { ...deepClone(this.curDist), dist: null })
      //   this.renderOrSearch(this.curDist.city)
      // }
    },
    async initData() {
      const data = await this.curLevelDistrict({ level: 1, districtCode: '1' })
      if (window.pMap) {
        window.pMap.clearMap()
      }
      data.forEach((v) => {
        const proInfo = Object.assign(v, {
          levelNum: 2,
          name: v.districtValue,
          names: v.districtValue,
          codes: v.districtCode
        })
        this.addRegionMarker(proInfo)
      })
      // 计算全国数据
      this.nationalData(data)
    },
    // 获取相应层级的点位聚合数据
    async curLevelDistrict(opt) {
      const load = Loading.service({ target: '#adMapBox' })
      const res = await this.fetch('/boss/deviceSlot/v2/getAllDeviceByCityCode', opt, 'get')
      load.close()
      if (res && res.code === 0) {
        return (res.data || []).map(d => {
          // 坐标转换(百度=>高德)
          const gcjPoint = GeoUtil.bd09ToGcj02(d.lon, d.lat)
          if (gcjPoint) {
            d.lon = gcjPoint.lng
            d.lat = gcjPoint.lat
          }
          return d
        }).sort((a, b) => a.deviceCount - b.deviceCount) // 按屏幕数升序排序
      }
      return []
    },
    nationalData(list) {
      const nationalStat = list.reduce((dist, curData) => {
        if (!dist.cityNum) dist.cityNum = 0
        if (!dist.deviceNum) dist.deviceNum = 0
        if (!dist.people) dist.people = 0
        if (!dist.dailyFlow) dist.dailyFlow = 0
        dist.cityNum += 1
        dist.deviceNum += curData.deviceCount
        dist.people += curData.audienceNumber
        dist.dailyFlow += curData.dailyFlow
        return dist
      }, {})
      this.$store.commit('setTopStat', nationalStat)
    },

    // 根据经纬度定位坐标点
    createFocus(p) {
      focusLayer = new AMap.LabelsLayer({
        collision: false,
        zooms: [3, 20],
        zIndex: 120
      })
      focusLayer.add(new AMap.LabelMarker({
        position: [p.lng, p.lat],
        icon: {
          anchor: 'bottom-center',
          image: `${PathPre}location.png`,
          size: [18, 25]
        }
      }))
      window._focusLayer = focusLayer
      window.pMap?.add(focusLayer)
    },

    // 更新小区Marker渲染(收到事件代表小区勾选状态一定发生了变化)
    handleUpdate(e) {
      if (e && e.detail) {
        const { guid, check, indeterminate } = e.detail
        const selected = check || indeterminate
        // console.log('收到事件', guid, check, indeterminate)
        // console.log('最新状态:', selected)
        const lbmks = window._labelLayer?.getAllOverlays()
        const target = lbmks.filter(m => m.getName() === guid)[0]
        if (target) {
          target.show()
          const ext = target.getExtData()
          ext.selected = selected
          target.setExtData(ext)
          const levelIcon = `${PathPre}nbhd_level${ext.gradeNum}.png`
          target.setIcon({
            anchor: 'bottom-center',
            image: selected ? levelIcon : `${PathPre}nbhd_uncheck.png`,
            size: [50, 30]
          })
        }
      }
    },
    // 渲染有推荐度的小区点集合
    createNbhdMarker() {
      if (!window._nbhds || !window._nbhds.length) return
      if (window._labelLayer) return

      console.time('渲染小区marker耗时')
      /**
       *  创建标注图层
       *! 高德JS-API标注层内部实现缺陷:
       *! LabelsLayer 的 collision&allowCollision 属性任一设置为true,
       *! 在LabelMarker数量较多时严重消耗性能导致地图拖动特别卡顿
       */
      window._labelLayer = new AMap.LabelsLayer({
        // allowCollision: false, // 标注层内的标注是否允许其它标注层对它避让
        collision: false, // 标注层内的标注是否避让
        zooms: [3, 20],
        zIndex: 150 // 需小于amap-markers的层级
      })
      window.pMap?.add(window._labelLayer)
      const vm = this
      const mkrs = window._nbhds.map((nbhd, _idx) => {
        const { guid, name, lon, lat, check, indeterminate, match } = nbhd
        const isSelected = check || indeterminate
        const recommendGrade = Math.round(match * 100)
        // 小区推荐度等级: 每20一个梯度,最小为1,最大为5
        const gradeNum = Math.min(5, Math.max(1, Math.ceil(recommendGrade / 20)))
        const levelIcon = `${PathPre}nbhd_level${gradeNum}.png`

        const nbhdMarker = new AMap.LabelMarker({
          name: guid, // 使用小区ID作为标注唯一标识(name标识并非展示在地图上的文字内容)
          position: [lon, lat],
          icon: {
            anchor: 'bottom-center',
            image: isSelected ? levelIcon : `${PathPre}nbhd_uncheck.png`,
            size: [50, 30]
          },
          text: {
            content: `${recommendGrade}%`,
            offset: [1, 23],
            style: {
              fillColor: '#fff',
              fontSize: 12
            }
          },
          extData: {
            nbhdId: guid,
            name: name,
            recommendGrade,
            gradeNum,
            selected: isSelected
          },
          // 标注层级
          // 根据小区推荐度设置层级,地图缩放LabelMarker重叠时推荐度高的优先展示
          zIndex: Math.ceil(match * 100),
          zooms: [3, 20]
        })
        nbhdMarker.on('mouseover', vm.hoverNbhdMarker)
        return nbhdMarker
      })
      window._labelLayer.add(mkrs)
      console.timeEnd('渲染小区marker耗时')
    },
    // 展示小区信息marker(全局唯一)
    hoverNbhdMarker(e) {
      const tar = e.target
      const { name, recommendGrade, selected, nbhdId } = tar.getExtData()
      const nameStr = name.length > 4 ? name.slice(0, 4) + '..' : name
      const hoverClass = selected ? 'hover_marker' : 'hover_marker uncheck'
      window._hoverMarker.setExtData({
        nbhdId
      })
      window._hoverMarker.setPosition(tar.getPosition())
      window._hoverMarker.setContent('<div class="' + hoverClass + '"><span class="check_icon"></span><span class="title">' +
        nameStr + ' ' + recommendGrade + '%' + '</span><i class="iconfont icon-qiehuanyou"></i></div>')
      window.pMap.add(window._hoverMarker)
    },

    async renderOrSearch(item) {
      if (item === null) return
      window.pMap?.clearMap()
      const lev = item.levelNum
      switch (lev) {
        // 点击省份
        case 2: {
          this.$store.commit('setZoomData', { ...deepClone(this.curDist), province: item })
          const lvData = await this.curLevelDistrict({ level: lev, districtCode: item.districtCode })
          lvData.forEach((d) => {
            const cityInfo = Object.assign(d, {
              levelNum: lev + 1,
              name: d.districtValue,
              names: item.names ? item.names + d.districtValue : d.districtValue,
              codes: item.codes ? item.codes + '-' + d.districtCode : d.districtCode
            })
            this.addRegionMarker(cityInfo)
          })
          // 获取所有【行政区标记】覆盖物并缩放地图到合适的视野级别
          window.pMap.setFitView(window.pMap.getAllOverlays('marker'), true, [80, 80, 80, 80])

          // 展示某个省的所有市,等级设为7.6,不同省份下展示效果相差不大
          // const t = setTimeout(() => {
          //   clearTimeout(t)
          //   window.pMap.setZoomAndCenter(7.6, [Number(item.lon), Number(item.lat)])
          // }, 200)
          break
        }
        // 点击城市,不展示区,直接请求小区列表
        case 3: {
          this.$store.commit('setZoomData', { ...deepClone(this.curDist), city: item })
          this.$store.commit('setFocusPoint', { location: { lng: item.lon, lat: item.lat } })
          this.$emit('chooseCity', item)
          break
        }
        default:
          break
      }
    },

    // 展示行政区(省、市两级)点标记
    async addRegionMarker(el) {
      let name = el.name
      if (el.levelNum === 2) {
        name = name.search(/内蒙古|黑龙江/) > -1 ? name.slice(0, 3) : name.slice(0, 2)
      } else {
        name = name && name.length > 3 ? name.slice(0, 3) + '...' : name || ''
      }

      const deviceNum = el.deviceCount > 1e4 ? (el.deviceCount / 1e4).toFixed(2) + '万' : el.deviceCount
      const normalText = `<div class="circle_text">${name}<br/><span class="text_thin">${deviceNum}个屏</span></div>`
      const hoverText = `<div class="circle_text">点击<br/><span class="text_thin">投放广告</span></div>`

      let coords = null
      if (el.lon && el.lat) {
        coords = new AMap.LngLat(el.lon, el.lat)
      } else {
        const result = await geoLocation(el.name)
        if (result && result.location) {
          coords = result.location
        }
      }
      if (coords) {
        const region = new AMap.Marker({
          anchor: 'center',
          position: coords,
          content: normalText,
          zIndex: 20, // 缺省为12
          extData: {
            normal: normalText,
            hover: hoverText,
            district: el
          }
        })
        region.on('click', () => {
          this.hoverProvince = {}
          this.renderOrSearch(el)
        })

        region.on('mouseover', this.onMouseover, region)
        region.on('mouseout', this.onMouseout, region)
        window.pMap?.add(region)
      }
    },

    onMouseover(e) {
      const marker = e.target
      const ext = marker.getExtData()
      marker.setContent(ext.hover)
      marker.setzIndex(30)
      this.hoverProvince = ext.district

      const pop = document.querySelector('.marker_province_info')
      const popH = pop.clientHeight
      const popW = pop.clientWidth
      const halfPop = Math.max(popH / 2, 100) // 浮窗高度的一半
      const mapSize = window.pMap?.getSize()
      const mStyle = marker._style
      const mHalfW = mStyle.size[0] / 2 // 文本标记宽度的一半
      const mHalfH = mStyle.size[1] / 2 // 文本标记高度的一半
      const mLeft = Math.floor(Number(mStyle.left.replace('px', ''))) // 标记的像素横坐标(移动地图会实时更新)
      const mTop = Number(mStyle.top.replace('px', '')) // 标记的像素纵坐标(移动地图会实时更新)
      let popLeft = 0
      let popTop = 0

      // marker靠近地图容器上、下、左、右边界情况处理
      // 下边界(纵坐标 + 一半浮窗高度 大于 地图容器高度)
      if (mTop + halfPop >= mapSize.height) {
        popTop = mTop - (popH + 10)
      } else if (mTop <= halfPop + mHalfH) {
        // 上边界(纵坐标小于一半浮窗高度 + 一半标记高度)
        popTop = e.pixel.y
      } else {
        popTop = mTop - halfPop
      }

      // 左边界(横坐标小于浮窗宽度+标记宽度的一半)
      if (mLeft <= popW + mHalfW) {
        popLeft = mLeft + mHalfW + 10
      } else {
        popLeft = mLeft - popW - mHalfW - 10
      }
      this.poperStyle = {
        left: popLeft,
        top: popTop
      }
    },

    onMouseout(e) {
      this.hoverProvince = {}
      const marker = e.target
      marker.setContent(marker.getExtData().normal)
      marker.setzIndex(20)
    },

    onZoomChange() {
      window.pMap.setZoom(this.curZoom)
    },
    destroyGroup() {
      if (this.circlePointGroup) {
        window.pMap.remove(this.circlePointGroup)
        this.circlePointGroup = null
      }
      if (this.expMarkerGroup) {
        window.pMap.remove(this.expMarkerGroup)
        this.expMarkerGroup = null
      }
    },
    fitMapView() {
      // 导入文件搜索,请求到的数据展示处理
      const impl = this.importData?.list
      if (impl && impl.length) {
        this.circleCenter(false) // 去掉中心圆圈和点
        this.$store.commit('setFocusPoint', '')
        this.showImportPointsAndCircles() // 导入excel搜索后点位marker及各圆圈渲染
        window.pMap?.setFitView(this.circlePointGroup?.getOverlays(), true)
      } else {
        this.destroyGroup()
        this.circleCenter(this.putRange !== '')
        if (this.circleSearchOverlay) { // 有投放范围
          window.pMap?.setFitView(this.circleSearchOverlay, true)
        } else { // 投放范围不限情况
          const overlays = this.pointsNeedFit()
          if (overlays && overlays.length) {
            // 多坐标点数据时设置最佳视图
            window.pMap?.setFitView(overlays, true)
            if (overlays.length == 1) { // 只有focusPointMarker的时候
              const s = setTimeout(() => {
                clearTimeout(s)
                window.pMap?.setZoomAndCenter(12, [this.curFocus.location.lng, this.curFocus.location.lat])
              }, 300)
            }
          }
        }
      }
    },
    circleCenter(isShow) {
      // 地理实际位置，可不输入，默认匹配处理合适半径
      if (this.circleSearchOverlay) {
        window.pMap?.remove(this.circleSearchOverlay)
        this.circleSearchOverlay.destroy()
        this.circleSearchOverlay = null
      }
      this.destroyGroup()
      if (!isShow || !this.curFocus.location) return
      // 默认根据缩放比例，处理半径
      const zoomRadius = {
        18: 200,
        17: 400,
        16: 800,
        15: 1600,
        14: 3200,
        13: 6400,
        12: 12800,
        11: 25600,
        10: 52100,
        9: 102400,
        8: 204800,
        7: 409600,
        6: 819600
      }

      const zm = window.pMap?.getZoom(0) // 缩放级别整数值
      // 地址搜索结果生成的白色虚线边圆形覆盖物对象
      this.circleSearchOverlay = new AMap.Circle({
        center: new AMap.LngLat(this.curFocus.location.lng, this.curFocus.location.lat) || window.pMap.getCenter(),
        radius: this.putRange * 1000 || zoomRadius[zm] || 200 * (19 - zm),
        strokeColor: 'rgba(255, 255, 255, 0.5)',
        strokeWeight: 1,
        strokeOpacity: 0.5,
        strokeStyle: 'dashed',
        fillColor: 'rgba(153, 153, 153, 0.5)',
        fillOpacity: 0.1
      })
      window.pMap.add(this.circleSearchOverlay)
    },
    showImportPointsAndCircles() {
      // 导入excel搜索点位时,先清空之前的坐标点(如果有的话)
      // this.expMarkerGroup?.clearOverlays()
      // 导入excel多个坐标点时的画圆圈
      // this.circlePointGroup?.clearOverlays()
      this.destroyGroup()

      if (this.importData.pointList) {
        let expMks = []
        this.importData.pointList.forEach((p) => {
          // 坐标转换(百度=>高德)
          const gcj = GeoUtil.bd09ToGcj02(p.lon, p.lat)
          expMks.push(new AMap.Marker({
            anchor: 'bottom-center',
            position: new AMap.LngLat(gcj.lng, gcj.lat),
            icon: mapIcon
          }))
        })
        this.expMarkerGroup = new AMap.OverlayGroup(expMks)
        window.pMap?.add(this.expMarkerGroup)

        if (this.putRange) { // 搜索范围存在时
          let circleArr = []
          this.importData.pointList.forEach((p) => {
            const gcj = GeoUtil.bd09ToGcj02(p.lon, p.lat)
            circleArr.push(new AMap.Circle({
              center: new AMap.LngLat(gcj.lng, gcj.lat),
              radius: Number(this.putRange) * 1000,
              strokeColor: 'rgba(255, 255, 255, 0.5)',
              strokeWeight: 1,
              strokeOpacity: 0.5,
              strokeStyle: 'dashed',
              fillColor: 'rgba(153, 153, 153, 0.5)',
              fillOpacity: 0.1
            }))
          })
          this.circlePointGroup = new AMap.OverlayGroup(circleArr)
          window.pMap?.add(this.circlePointGroup)
        }
      }
    },
    // 需要适配视野的点集合
    pointsNeedFit() {
      if (window._nbhds && window._nbhds.length) {
        // 优先均匀展示点位分布
        const mks = window._labelLayer?.getAllOverlays() || []
        const focus = window._focusLayer?.getAllOverlays() || []
        if (focus && focus.length) mks.push(...focus)
        return mks
      } else if (this.curFocus && this.curFocus.location) {
        return window._focusLayer.getAllOverlays() || []
      }
      return []
    },

    onSearch(value) {
      console.log('onSearch', value)
      this.$emit('search',value)
    },

    // 确认订单返回使用
    freshMapPointLabel() {
      window.pMap?.clearMap()
      if (window._labelLayer) {
        window.pMap.remove(window._labelLayer)
        window._labelLayer = null
      }
      this.createNbhdMarker()
      const t = setTimeout(() => {
        clearTimeout(t)
        this.fitMapView()
      }, 300)
    },

    noneTip() {
      this.searchNone = true
      const dt = setTimeout(() => {
        clearTimeout(dt)
        this.searchNone = false
      }, 2500)
    }
  }
}
</script>

<style lang="scss" scoped>
.region_map_box {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 760px;
  &.adjust {
    width: calc(100% - 160px);
  }
  .map_container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  .search_none {
    position: absolute;
    top: 52%;
    left: 50%;
    width: 120px;
    height: 30px;
    line-height: 30px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 15px;
    box-shadow: 0 0 1px 1px #666;
    color: #fff;
    text-align: center;
    transform: translate(-50%, -50%);
    z-index: 99;
  }
}
</style>

<style lang="scss">
$icon-path: '/map/';

.map_container {
  .amap-markers {
    z-index: 300;
    .circle_text {
      display: inline-block;
      cursor: pointer;
      width: 70px;
      height: 70px;
      background: linear-gradient(315deg, #9f9f9f 0%, #666 100%);
      border: 4px solid #a4a4a4;
      border-radius: 50%;
      color: #fff;
      font-size: 14px;
      position: relative;
      padding-top: 14px;
      text-align: center;
      word-break: break-all;
      &:hover {
        z-index: 1;
        border-color: rgba(255, 255, 255, 0.3);
        background: linear-gradient(315deg, #FF846D 0%, #FF3973 100%);
      }
      .text_thin {
        font-size: 12px;
      }
    }
    .hover_marker {
      width: 140px;
      height: 36px;
      color: #282729;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 32px;
      font-size: 12px;
      background: url('#{$icon-path}nbhd_check_hover.png') 100% 100% no-repeat;
      background-size: 100% 100%;
      padding: 0 9px 2px;
      text-align: center;
      user-select: none;
      white-space: nowrap;
      &.uncheck {
        background: url('#{$icon-path}nbhd_uncheck_hover.png') 100% 100% no-repeat;
        background-size: 100% 100%;
        .check_icon::after {
          content: none;
        }
      }
      .check_icon {
        position: relative;
        cursor: pointer;
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        border: 1px solid #282729;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 2px;
        margin-bottom: 2px;
        &::after {
          position: absolute;
          left: 1px;
          top: 0;
          content: '√';
          color: #282729;
          text-align: center;
          line-height: 12px;
          font-weight: bolder;
          transform: scale(0.8);
        }
      }
      .title {
        cursor: pointer;
        flex-shrink: 0;
        margin: 0 1px;
      }
      .icon-qiehuanyou {
        font-size: 12px;
        line-height: 26px;
      }
    }
  }
  .amap-controls .amap-scalecontrol {
    background-color: transparent;
    bottom: 10px !important;
    right: 80px !important;
    .amap-scale-text {
      color: #fff;
    }
    .amap-scale-line {
      left: 3px;
    }
    .amap-scale-edgeleft {
      background-color: #fff;
      border: none;
      left: 1px;
    }
    .amap-scale-middle {
      height: 1px;
      background-color: #fff;
      border: none;
      top: 5px;
    }
    .amap-scale-edgeright {
      background-color: #fff;
      border: none;
    }
  }
}
</style>
